<script>  
  import { onMount } from 'svelte';
  import { selectedGroup } from '../store.js';
  import Tabs from '../layout/Tabs.svelte';
  import VesselOverview from '../componentcontent/VesselOverview.svelte';
  import Systems from '../componentcontent/Systems.svelte';
  import OnboardSoftware from '../componentcontent/OnboardSoftware.svelte';
  import { Card, CardBody, CardHeader, CardTitle } from 'sveltestrap';
  import http from '../api/http.js';
  import UnmanagedEndpoints from '../pages/UnmanagedEndpoints.svelte';
  import { navigate } from 'svelte-routing';
  

  export let id;
  export let urlTab;
  let vessel;
  let activeTab;
  
  //tabs
  let tabs = ['Vessel Overview', 'Managed Endpoints', 'Unmanaged Endpoints', 'Package Catalogue']
  
  if (!urlTab){
    activeTab = 'Vessel Overview';
  }else{
    switch(urlTab) {
      case 'computers':
        activeTab = 'Managed Endpoints';
        break;
        case 'unmanagedendpoints':
        activeTab = 'Unmanaged Endpoints';
        break;
      case 'onboardSoftware':
        activeTab = 'Onboard Software';
        break;
      default:
        activeTab = 'Overview';
    }
  };
  const changeTab = (e) => {
    activeTab = e.detail;
    switch(activeTab) {
      case 'Managed Endpoints':
        urlTab = 'computers';
        break;
        case 'Unmanaged Endpoints':
        urlTab = 'unmanagedendpoints';
        break;
      case 'Onboard Software':
        urlTab = 'onboardSoftware';
        break;
      default:
        urlTab = 'overview';
    }
    navigate(`/vessel/${id}/${urlTab}`);
  }    

  async function getVessel(){
  const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/${id}/${$selectedGroup}`);
  vessel = await res.json();
  vessel.selected = true;
}
  
</script>
<style>
    
</style>
{#await getVessel()}
<p>Loading vessel data...</p>
{:then}
<div class="d-flex mb-4">
  <h5 class="m-0 font-weight-bold text-primary">{vessel.name}</h5>
  <div class="ml-auto">
    <Tabs {tabs}{activeTab} on:tabChange={changeTab}></Tabs>
  </div>
</div>
    {#if activeTab === 'Vessel Overview'}<VesselOverview vessel={vessel}></VesselOverview>{/if}
    {#if activeTab === 'Managed Endpoints'}<Systems vessel={vessel}></Systems>{/if}
    {#if activeTab === 'Unmanaged Endpoints'}<UnmanagedEndpoints byVessel={true} vesselId={id}></UnmanagedEndpoints>{/if}
    {#if activeTab === 'Package Catalogue'}<OnboardSoftware vesselObj={vessel}></OnboardSoftware>{/if}  
{/await}
